// extracted by mini-css-extract-plugin
module.exports = {"navTabBar":"TopBar_navTabBar__1RJ1-","whiteText":"TopBar_whiteText__3yiVG"};